import React, { useEffect, useState } from 'react'
import API from '../../../../services/API'
import { Alert, LinearProgress, Stack, Typography } from '@mui/material'
import CustomDataGrid from '../../../../components/DataGrid/CustomDataGrid'
import moment from 'moment'
import RecentPopup from './RecentPopup'

const MyRecentEPCRs = () => {
  const [loading, setLoading] = useState(true)
  const [records, setRecords] = useState([])
  const [fetchError, setFetchError] = useState(false)
  const [selectedEPCR, setSelectedEPCR] = useState(null)

  useEffect(() => {
    API.get('/my-recent-epcrs')
      .then((res) =>
        res.status === 200 ? setRecords(res.data) : setFetchError(true),
      )
      .catch(() => setFetchError(true))
      .finally(() => setLoading(false))
  }, [])

  return (
    <Stack gap={1}>
      <Typography variant="title2">My Recent ePCRs</Typography>
      {fetchError && (
        <Alert severity="error">
          Unable to load recent ePCRs. Please try again later.
        </Alert>
      )}
      <CustomDataGrid
        rows={records}
        loading={loading}
        color="anPurple"
        getRowId={(row) => row._id}
        // onRowClick={({ row }) => console.log(row._id)}
        onRowClick={({ row }) => setSelectedEPCR(row._id)}
        columns={[
          {
            field: 'patient',
            headerName: 'Patient',
            valueGetter: (value, row) =>
              (row?.demographics?.lastNameUnknown ||
              (!row?.demographics?.lastName && !row?.demographics?.firstName)
                ? 'Unknown'
                : `${
                    row.demographics?.lastName ??
                    '' + ', ' + row?.demographics?.firstName[0] ??
                    ''
                  }`) +
              ', ' +
              (row?.demographics?.dobUnknown || !row?.demographics?.dob
                ? 'Unknown Age'
                : moment().diff(moment(row.demographics.dob), 'years')),
            minWidth: 200,
            flex: 1,
          },
          {
            field: 'incidentType',
            headerName: 'Incident',
            valueGetter: (value, row) =>
              row?.mode === 'Critical Care'
                ? `Critical Care · ${row?.incident?.incidentType ?? ''}`
                : row.incident.incidentType,
            minWidth: 200,
            flex: 0.6,
          },
          {
            field: 'outcome',
            headerName: 'Outcome',
            valueGetter: (value, row) => row?.mode === 'Welfare' ? 'Welfare' : row?.plan?.ptOutcome,
            minWidth: 200,
            flex: 0.6,
          },
        ]}
        disableRowSelectionOnClick
        slots={{
          toolbar: () => null,
          footer: () => null,
        }}
      />
      <RecentPopup
        open={!!selectedEPCR}
        onClose={() => setSelectedEPCR(null)}
        epcrID={selectedEPCR}
      />
    </Stack>
  )
}

export default MyRecentEPCRs
